import { render, staticRenderFns } from "./OccurrenceInfoBlock.vue?vue&type=template&id=5cb2ea8e&scoped=true&"
import script from "./OccurrenceInfoBlock.vue?vue&type=script&lang=js&"
export * from "./OccurrenceInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceInfoBlock.vue?vue&type=style&index=0&id=5cb2ea8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2ea8e",
  null
  
)

export default component.exports